import { useParams } from 'react-router-dom';
import ProductHero, { ProductContainer } from '../components/product/ProductHero';
import ProductBody from '../components/product/ProductBody';
import { getSolutionBySlug } from '../assets/solutions';
import { useI18n } from '../i18n';
import SeoHead from '../components/SeoHead';
import NotFoundPage from './NotFoundPage';
import { SITE_ORIGIN } from '../config/site';
const SolutionDetailPage = () => {
  const { solutionSlug } = useParams();
  const { locale } = useI18n();
  const solutionData = getSolutionBySlug(solutionSlug, locale);

  if (!solutionData) {
    return <NotFoundPage />;
  }

  const ogImage = solutionData.backgroundImage
    ? `${SITE_ORIGIN}${solutionData.backgroundImage}`
    : undefined;

  return (
    <>
      <SeoHead
        title={solutionData.meta.title}
        description={solutionData.meta.description}
        keywords={solutionData.meta.keywords}
        path={`/solutions/${solutionSlug}`}
        image={ogImage}
      />
      <ProductContainer>
        <ProductHero product={solutionData} />
        <ProductBody product={solutionData} slug={solutionSlug} />
      </ProductContainer>
    </>
  );
};

export default SolutionDetailPage;
